module.exports = __webpack_public_path__ + "static/img/Turf-Bar.4e7ffcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Turf-Bar.jpg
// module id = LcMU
// module chunks = 0